import { AxiosInstance } from "@bps/http-client";

import { ISystemGateway } from "./system.gateway.interface";

export class SystemGateway implements ISystemGateway {
  constructor(private api: AxiosInstance) {}
  private readonly appConfigPath = "appConfiguration";

  public getAppConfig = async () => {
    const res = await this.api.get(this.appConfigPath);

    return res.data;
  };
}
